<script setup lang="ts">
import AdminAnnouncementColorEnum from '@/domains/admin/typescript/AdminAnnouncementColorEnum';
import type AdminAnnouncementInterface from '@/domains/admin/typescript/AdminAnnouncementInterface';

const { announcement } = defineProps<{ announcement: AdminAnnouncementInterface }>();

function getColor(color: AdminAnnouncementColorEnum): Record<string, string> {
    switch (color) {
        case AdminAnnouncementColorEnum.DANGER:
            return { background: 'bg-error-bg', text: 'text-theme-black', border: 'border-error' };
        case AdminAnnouncementColorEnum.SUCCESS:
            return { background: 'bg-success-bg', text: 'text-theme-black', border: 'border-success' };
        case AdminAnnouncementColorEnum.WARNING:
            return { background: 'bg-warning-bg', text: 'text-theme-black', border: 'border-warning' };
        case AdminAnnouncementColorEnum.OCTOBRE_ROSE:
            return { background: 'bg-octobre-rose', text: 'text-octobre-black', border: 'border-octobre-rose' };
        case AdminAnnouncementColorEnum.INFO:
        default:
            return { background: 'bg-blue-500', text: 'text-white', border: 'border-blue-500' };
    }
}

const emit = defineEmits<{
    'hide': [id: number];
}>();

function hideAnnouncement(id: number) {
    emit('hide', id);
}
</script>

<template>
    <BaseGlobalAnnouncement
        :id="announcement.id"
        :message="announcement.title"
        :closable="!announcement.unclosable"
        :side-effect="announcement.sideEffect"
        :bg-color="getColor(announcement.color).background"
        :text-color="getColor(announcement.color).text"
        @hide="hideAnnouncement"
    />
</template>
